import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../../../components/shared/Loading";
import PageContainer from "../../../../components/template/PageContainer";
import {
  validateAdminParams,
  validateProjectListSearch,
} from "../../../../router/admin-validation";
import { requireRoles } from "../../../../router/auth";
import type { RouteMetadata } from "../../../../router/metadata";

const Screen = lazy(
  () => import("../../../../views/administrator/projects/list"),
);

export const Route = createFileRoute(
  "/_protected/(admin)/list-projects/$companyId",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => requireRoles(context.authSnapshot, ["Admin"]),
  params: { parse: validateAdminParams },
  validateSearch: validateProjectListSearch,
  staticData: {
    routeKey: "projects-list",
    access: "admin",
    layout: "modern",
    container: "default",
    footer: false,
    requiredRoles: ["Admin"],
  } satisfies RouteMetadata,
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <PageContainer
        pageContainerType={Route.options.staticData?.container}
        footer={Route.options.staticData?.footer}
      >
        <Screen />
      </PageContainer>
    </Suspense>
  );
}
